export default "__VITE_ASSET__d5141a5d__"